<template>
  <div class="text-block">
    <h3 class="text-title">{{ title }}</h3>
    <p class="text-content">{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'InfoText',
  props: {
    title: String,
    content: String
  }
};
</script>

<style scoped>
.text-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.text-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.text-content {
  font-size: 15px;
  color: #4f4f4f;
  line-height: 1.6;
}
</style>
